import { Col } from '@/components';
import { AccountingTypeOptionSelectField } from '@/features/master-table/components';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const AccountingTypeColField: FC = memo(() => {
  const { t } = useTranslation();
  const { control: sharedSearchControl, resetField } =
    useFormContext<SharedSearchFormType>();

  const { control: analysisSearchControl } =
    useFormContext<AnalysisSearchFormType>();

  const sheetType = useWatch({
    control: sharedSearchControl,
    name: 'sheetType',
  });
  const analysisTarget = useWatch({
    control: analysisSearchControl,
    name: 'analysisTarget',
  });

  if (sheetType !== 'RS' || analysisTarget === 'payment') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <AccountingTypeOptionSelectField
        name="accountingType"
        label={t('accounting-type')}
        hint={t('hint-search-accounting-type')}
        shouldCoexistOnChange
        onChange={() => {
          resetField('accountingTypeIds', {
            defaultValue: null as any,
          });
        }}
        width="100%"
      />
    </Col>
  );
});
